import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    NgModule,
    OnInit
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Cms } from '@impact/data';
import { take } from 'rxjs/operators';
import { GlobalDataService } from '../../core/global-data.service';
import { SettingsService } from '../../core/settings.service';
import { Environment, ENVIRONMENT } from '../../environment/environment';
import { MetaService } from '../../meta/meta.service';
import { SpotsUiModule } from '../../spots/spots-ui.module';
import { resolveMediaUrl } from '../../utils/helpers/media-helpers';

@Component({
    selector: 'app-campaign-page',
    template: `
        <main>
            <section class="page-grid-content">
                <app-spot-grid [grid]="campaign?.mainGrid"></app-spot-grid>
            </section>
        </main>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignPageComponent implements OnInit {
    @Input() data: Cms.CampaignPage;

    campaign: Cms.GlobalCampaignDto | undefined;

    constructor(
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private globalDataService: GlobalDataService,
        private metaService: MetaService,
        private settingsService: SettingsService,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {}

    ngOnInit() {
        const params = this.route.snapshot.queryParams;

        if (!params?.id) {
            console.error('[BN Error: No campaign id provided]');
            return;
        }

        this.globalDataService.getGlobalCampaigns().subscribe((campaigns) => {
            this.campaign = campaigns.children.find((c) => c.id === params.id);

            if (!this.campaign) {
                return this.notFound();
            }

            this.setMetaData(this.campaign);
            this.cdr.markForCheck();
        });
    }

    private notFound() {
        this.settingsService
            .get()
            .pipe(take(1))
            .subscribe((s) => {
                const notFoundUrl = s.globalPages?.notFoundPage?.url;
                this.router.navigateByUrl(notFoundUrl ?? '/');
            });
    }

    private setMetaData(campaign: Cms.GlobalCampaignDto) {
        const title = campaign.title;
        const description = campaign.introText;
        const image = campaign.campaignImage;

        this.metaService.setTitle(title);
        this.metaService.setDescription(description);

        // Open graph
        this.metaService.setOpenGraph({
            title: title || '',
            image: image
                ? {
                      url: resolveMediaUrl(image.src, this.environment, {
                          width: 1200,
                          height: 630,
                          rmode: 'crop',
                      }),
                      altText: image.alt,
                      width: '1200',
                      height: '630',
                  }
                : undefined,
            type: 'website',
            author: '',
        });
    }
}
@NgModule({
    declarations: [CampaignPageComponent],
    imports: [CommonModule, SpotsUiModule],
})
class CampaignPageModule {}

export const LazyComponent = CampaignPageComponent;
